import type { AttributeUsage } from './types';

// Looks up the live-usage count for a single dictionary value.
// state/origin values feed master_products columns directly, so they read
// their own buckets by value; every other type is EAV and reads the eav
// bucket keyed by (attributeType key, attributeValue). Missing entries -> 0.
export const usageFor = (usage: AttributeUsage | undefined, typeKey: string, value: string): number => {
  if (!usage) return 0;

  if (typeKey === 'state') {
    return usage.state.find((s) => s.value === value)?.count ?? 0;
  }

  if (typeKey === 'origin') {
    return usage.origin.find((o) => o.value === value)?.count ?? 0;
  }

  return usage.eav.find((e) => e.attributeType === typeKey && e.attributeValue === value)?.count ?? 0;
};
